import { Action, Module, VuexModule } from "vuex-class-modules";
import { EventTopic, EventType } from "@gsx/common";
import { ICountry, ICity } from "vendor/country-state-city";

@Module({ generateMutationSetters: true })
export class ConferenceFilterStore extends VuexModule {
    topics: Set<EventTopic> = new Set();
    types: Set<EventType> = new Set();
    countries: Set<ICountry["name"]> = new Set();
    cities: Set<ICity["name"]> = new Set();
    search: string = "";
    logicalOperator: "AND" | "OR" = "AND";

    @Action
    public toggleCountry(name: ICountry["name"]): void {
        const countries = new Set(this.countries.values());

        if (countries.has(name)) {
            countries.delete(name);
        } else {
            countries.add(name);
        }

        this.countries = countries;
    }

    @Action
    public toggleCity(name: ICity["name"]): void {
        const cities = new Set(this.cities.values());

        if (cities.has(name)) {
            cities.delete(name);
        } else {
            cities.add(name);
        }

        this.cities = cities;
    }

    @Action
    public toggleTopic(name: EventTopic): void {
        const topics = new Set(this.topics.values());

        if (topics.has(name)) {
            topics.delete(name);
        } else {
            topics.add(name);
        }

        this.topics = topics;
    }

    @Action
    public toggleType(name: EventType): void {
        const types = new Set(this.types.values());

        if (types.has(name)) {
            types.delete(name);
        } else {
            types.add(name);
        }

        this.types = types;
    }

    @Action
    public resetFilters(): void {
        this.topics = new Set();
        this.types = new Set();
        this.countries = new Set();
        this.cities = new Set();
        this.search = "";
    }
}
